export enum ParamterType {
    NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}
